// src/components/common/TabPanel.tsx
import React, { memo } from 'react';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  keepMounted?: boolean;
}

/**
 * Memoized TabPanel component to prevent unnecessary re-renders.
 * Use keepMounted=true to preserve state when switching tabs.
 */
const TabPanel: React.FC<TabPanelProps> = ({ children, value, index, keepMounted = false }) => {
  const isActive = value === index;

  // If not keepMounted, only render when active
  if (!keepMounted && !isActive) {
    return null;
  }

  return (
    <div
      role="tabpanel"
      hidden={!isActive}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      style={{ display: isActive ? 'block' : 'none' }}
    >
      {children}
    </div>
  );
};

export default memo(TabPanel);
